import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapTariffInvoiceFromServer = getDataMapper({
    id: mapField("id", Number),
    number: mapField("number"),
    sum: mapField("sum", Number),
    status: mapField("status"),
    kind: mapField("kind"),
    directorId: mapField("director_id", Number),
    directorFio: mapField("director_fio"),
    createdAt: mapField("created_at"),
    paidAt: mapField("paid_at"),
});

export const mapTariffInvoicesFromServer = mapArray(mapTariffInvoiceFromServer);
